import React, { useState, useEffect } from 'react';
import './HeroBanner.css';
import { useNavigate } from 'react-router-dom';

const HeroBanner = () => {
  const [hover, setHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in by checking for token in localStorage
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  return (
    <section className="home-banner text-center py-5">
      <div className="container">
        <h1 className="hero-title">The Live Auction Platform</h1>
        <p className="hero-subtitle">Experience the excitement of real-time player bidding for sports teams</p>
        
        <div className="cta-buttons">
          <button
            className={`btn-cta ${hover ? 'hovered' : ''}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => navigate('/auctions')}
          >
            Watch Live Auctions
          </button>
          
          {!isLoggedIn && (
            <button
              className={`btn-register ${registerHover ? 'hovered' : ''}`}
              onMouseEnter={() => setRegisterHover(true)}
              onMouseLeave={() => setRegisterHover(false)}
              onClick={() => navigate('/register')}
            >
              Register Now
            </button>
          )}
        </div>
      </div>

      {/* Decorative Floating Circles */}
      <div className="floating-circle float-one"></div>
      <div className="floating-circle float-two"></div>
    </section>
  );
};

export default HeroBanner;